// Metric card: label, large value, optional hint, icon tile in the corner.
export function StatCard({ label, value, hint, icon: Icon, valueColor }) {
  return (
    <div className="stat-card">
      <div className="relative z-[1] min-w-0">
        <p className="stat-card__label">{label}</p>
        <strong className="stat-card__value" style={valueColor ? { color: valueColor } : undefined}>{value}</strong>
        {hint && <small className="stat-card__hint">{hint}</small>}
      </div>
      {Icon && <span className="stat-card__icon"><Icon size={20} /></span>}
    </div>
  );
}
